const AnalysisECGStaus = {
  PAIRED: 'paired',
  EXPORTED: 'exported',
} as const;

type AnalysisECGStaus = typeof AnalysisECGStaus[keyof typeof AnalysisECGStaus];

export { AnalysisECGStaus };
